module.exports = __webpack_public_path__ + "static/media/align-left.20f1d7c1.svg";